import { Injectable } from '@angular/core';
import { GeneralService } from './general.service';
import { HttpClient } from '@angular/common/http';
import { DynamicPageService } from './dynamic-page.service';
import { environment } from '../../../environments/environment';
import { InputsGeneralForm, InputUploadLigh } from '../models/pages-model/form-general.model';
import { GeneralFormPage } from '../models/pages-model/page-general.model';

@Injectable({
  providedIn: 'root',
})
export class ToolPagesService {
  public URL_API = environment.apiURLNew;

  constructor(
    private http: HttpClient,
    private dynamicPageService: DynamicPageService,
    private generalService: GeneralService,
  ) {}

  // Inyecta los catálogos a los inputs que los requieren
  public catalogs(input: InputsGeneralForm) {
    if (
      (input.typeInput === 'input-general-select' ||
        input.typeInput === 'input-general-autocomplete') &&
      typeof input.urlCatalog === 'string' &&
      input.urlCatalog.trim().length > 1
    ) {
      this.http.get<any>(this.URL_API + input.urlCatalog, {}).subscribe({
        next: (ress) => {
          if (ress) {
            input.arrayData = ress.map((item: any) => ({
              ...item,
              value: String(item.value),
            }));
            input.inputSelect = { value: 'value', description: 'description' };
          }
        },
        error: () => {
          console.error('Error al cargar el catálogo: input ', input);
        },
      });
    }
  }

  // Funcion Catalogo (Inyecta catalogo a otro Select)
  public catalogFunction(input: InputsGeneralForm, fields: InputsGeneralForm[]) {
    const Input = fields.find(
      (item) => String(item.idControl) === String(input.functionEvent?.catalog.input),
    );
    const body: any = {};

    if (input.functionEvent?.catalog.arrayParam && input.functionEvent.catalog.arrayParam.length) {
      input.functionEvent.catalog.arrayParam.forEach((paramAux) => {
        const InputAuxParam = fields.find(
          (item) => String(item.idControl) === String(paramAux.inputIdParam),
        );
        if (InputAuxParam) {
          if (paramAux.nameParam != '') {
            if (InputAuxParam.typeInput == 'input-general-select') {
              InputAuxParam.arrayData.forEach((item) => {
                if (item.value == InputAuxParam.formControl?.value) {
                  if (item.id) {
                    body[paramAux.nameParam] = item.id;
                  } else {
                    body[paramAux.nameParam] = input.formControl?.value;
                  }
                }
              });
            }
          }
        }
      });
    }

    if (Input) {
      if (input.functionEvent?.catalog.nameParam != '') {
        if (input.typeInput == 'input-general-select') {
          input.arrayData.forEach((item) => {
            if (item.value == input.formControl?.value) {
              if (item.id) {
                body[input.functionEvent?.catalog.nameParam ?? ''] = item.id;
              } else {
                body[input.functionEvent?.catalog.nameParam ?? ''] = input.formControl?.value;
              }
            }
          });
        }
      }

      if (Object.keys(body).length !== 0) {
        const params = this.generalService.buildParams(body);
        this.http
          .get<any>(this.URL_API + input.functionEvent?.catalog.url, { params: params })
          .subscribe((ress) => {
            if (ress) {
              if (Input.typeInput === 'input-general-select') {
                Input.inputSelect = { value: 'value', description: 'description' };
                Input.arrayData = ress.map((item: any) => ({
                  ...item,
                  value: String(item.value),
                }));
              }
            }
          });
      }
    }
  }

  // Lógica para ordernar campos segun reglas de ordenamiento
  public orfernByRuleFields(
    input: InputsGeneralForm,
    multifrom: {
      fields: InputsGeneralForm[];
      repeatIndex: number;
    },
    form: GeneralFormPage,
  ) {
    if (
      form.generateForm.formGroups &&
      form.generateForm.formGroups.orderByRule?.orderRule &&
      input.formControl
    ) {
      const orderRules = form.generateForm.formGroups.orderByRule.orderRule;
      const orderDefault = form.generateForm.formGroups.orderByRule.orderDefault;
      const currentVal = input.formControl.value;

      const matchingRule = Object.values(orderRules).find(
        (rule) =>
          rule?.inputKey &&
          String(rule.inputKey.parentFieldId) === String(input.idControl) &&
          (rule.inputKey.parentFieldValue === currentVal ||
            (rule.inputKey.parentFieldValue != null &&
              currentVal != null &&
              String(rule.inputKey.parentFieldValue) === String(currentVal))),
      );

      if (matchingRule) {
        multifrom.fields.forEach((inputAux, index) => {
          const orderData = matchingRule.orderInputs[inputAux.idControl];
          inputAux.order = orderData ? orderData.order : 999 + index;
        });

        multifrom.fields.sort(
          (a, b) => (a.order ?? Number.MAX_SAFE_INTEGER) - (b.order ?? Number.MAX_SAFE_INTEGER),
        );
      } else {
        const isParent = Object.values(orderRules).some(
          (rule) =>
            rule?.inputKey && String(rule.inputKey.parentFieldId) === String(input.idControl),
        );
        if (isParent && orderDefault && Object.keys(orderDefault).length) {
          multifrom.fields.forEach((inputAux, index) => {
            const orderData = orderDefault[inputAux.idControl];
            inputAux.order = orderData ? orderData.order : 999 + index;
          });
          multifrom.fields.sort(
            (a, b) => (a.order ?? Number.MAX_SAFE_INTEGER) - (b.order ?? Number.MAX_SAFE_INTEGER),
          );
        }
      }
    }
  }

  public autoSave(input: InputsGeneralForm, quotationId: number) {
    if (
      (input.formControl?.dirty || input.formControl?.touched) &&
      input.typeInput !== 'input-upload-ligh' &&
      input.typeInput !== 'input-general-autocomplete'
    ) {
      const key = input.idFullControl;
      const parts = key.split('-');
      const repeatIndex = parts[2];
      const idControl = parts[3];
      this.dynamicPageService
        .saveInput({
          idCotizacion: quotationId,
          controlId: parseInt(idControl),
          newValue: input.formControl.value,
          roleType: input.roleType !== '0' ? input.roleType : '',
          repeatIndex: parseInt(repeatIndex),
        })
        .subscribe();
    }
  }

  public autoSaveFileLigh(input: InputUploadLigh, quotationId: number) {
    const file: File = input.formControl?.value?.[0];
    if (input.function == 'XML') {
      if (file) {
        const documentData = `{"QuotationId":${quotationId},"DocumentId":0,"QuotationDocId":${input.AdditionalValuesFiles[0].iD_DOCUMENTOS_COTIZACION},"CoverId":${input.AdditionalValuesFiles[0].iD_CARATULA},"Index":"","IndexValue":"","Description":"${input.AdditionalValuesFiles[0].legacyFileName}","UserId":${localStorage.getItem('idUser') || 1}}`;
        const formData = new FormData();
        formData.append('file', file);
        formData.append('documentData', documentData);
        this.dynamicPageService.uploadDocument(formData).subscribe((ress) => {
          if (!ress.hasErrors) {
            this.generalService.viewSnacAlert(
              'Archivo subido',
              'normal',
              input.label + ' guardado',
            );
          } else {
            this.generalService.viewSnacAlert(
              'A ocurrido un error',
              'alert',
              'Error al guardar ' + input.label,
            );
          }
        });
      }
    } else if (input.typeInput === 'input-upload-ligh' && input.formControl?.touched) {
      if (file) {
        const documentData = `{"QuotationId":${quotationId},"DocumentId":0,"QuotationDocId":${input.AdditionalValuesFiles[0].iD_DOCUMENTOS_COTIZACION},"CoverId":${input.AdditionalValuesFiles[0].iD_CARATULA},"Index":"","IndexValue":"","Description":"${input.AdditionalValuesFiles[0].legacyFileName}","UserId":${localStorage.getItem('idUser') || 1}}`;
        const formData = new FormData();
        formData.append('file', file);
        formData.append('documentData', documentData);
        this.dynamicPageService.uploadDocument(formData).subscribe((ress) => {
          if (!ress.hasErrors) {
            this.generalService.viewSnacAlert(
              'Archivo subido',
              'normal',
              input.label + ' guardado',
            );
          } else {
            this.generalService.viewSnacAlert(
              'A ocurrido un error',
              'alert',
              'Error al guardar ' + input.label,
            );
          }
        });
      }
    }
  }
}
